import { proxy } from 'valtio';
export const useVolumeStore = proxy({
    data: [],
});
